import { Result, Button } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="このページは存在しません。"
      extra={
        <Link to="/">
          <Button type="primary">ホームに戻る</Button>
        </Link>
      }
    />
  );
};

export default NotFoundPage;
